module.exports = __webpack_public_path__ + "img/关于我们—培训.06f914dc.jpg";